import {InjectionKey, Ref} from "vue";

export const isInSelectedSectionInjectionKey = Symbol() as InjectionKey<Ref<boolean>>;